import React, { Component } from 'react';
import Button from 'material-ui-beta/Button';
import AppBar from 'material-ui-beta/AppBar';
import Toolbar from 'material-ui-beta/Toolbar';

import './AdminAppBar.css';

class AdminAppBar extends Component {

    onGoToLocationFinderClick = () => {
        document.location.href = "/#";
    }

    render() {
        return (
            <AppBar position="static" color="primary">
                <Toolbar>
                    <div className="flex flex1">
                        <div className="flex alignCenter flex1 alignLeft oswald admin-appbar-title">
                            {this.props.title}
                        </div>
                        <div>
                            <Button onClick={this.onGoToLocationFinderClick}>Location Finder</Button>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
        )
    }

}

export default AdminAppBar;


// WEBPACK FOOTER //
// ./src/components/admin-appbar/AdminAppBar.js